import { GraftsToAssignTable } from '@/components/Templates/Utilities/GraftsToAssign';

const GraftsToAssign = () => {
  return (
    <GraftsToAssignTable />
  )
}

export default GraftsToAssign;
